import { Component, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';

import { ActivatedRoute } from '@angular/router';
import * as moment from "node_modules/moment/moment";
import { Acesso } from 'src/app/core/acesso';
import { CarregarPerfil } from 'src/app/core/carregar-perfil';
import { FrequenciaAlunoService } from 'src/app/services/frequencia-aluno/frequencia-aluno.service';
import { ToastService } from 'src/app/services/toast/toast.service';
import { FrequenciaAlunoUnidade } from '../../core/frequencia-aluno-unidade';
import { Unidade } from '../../core/unidade';
import { DataUtilService } from '../../services/commons/data-util.service';
import { UnidadeService } from '../../services/unidade/unidade.service';


class FiltroBusca {
  dataReferencia: Date;
  unidade: Unidade = new Unidade();
}

@Component({
  selector: 'frequencia-aluno-unidade',
  templateUrl: './frequencia-aluno-unidade.component.html',
  styleUrls: ['./frequencia-aluno-unidade.component.css']
})
export class FrequenciaAlunoUnidadeComponent implements OnInit {

  public maskData = [/\d/, /\d/, '/', /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/];

  // Campos de busca
  filtroBusca: FiltroBusca = new FiltroBusca();

  frequenciaAlunoUnidade: FrequenciaAlunoUnidade = new FrequenciaAlunoUnidade();
  listaFrequenciaAlunoUnidade: FrequenciaAlunoUnidade[];

  
  maxDate = new Date();
  minDate = moment('1111-1-1', 'YYYY-MM-DD');

  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort, {static: true}) sort: MatSort;

  unidades: Unidade[];

  msg: string;
  perfilAcesso: Acesso = new Acesso();
  carregarPerfil: CarregarPerfil  = new CarregarPerfil();

  mostrarBotaoGerarListaFrequencia = false;
  mostrarTabela = false;
  displayedColumns: string[] = ['nome', 'matriculaAluno', 'datafrequencia', 'justificativa', 'presenca', 'ausencia', 'acoes'];
  dataSource: MatTableDataSource<FrequenciaAlunoUnidade> = new MatTableDataSource();

  constructor(
    private frequenciaAlunoService: FrequenciaAlunoService,
    private unidadeService: UnidadeService,
    private toastService: ToastService,
    private dialog: MatDialog,
    private activatedRoute: ActivatedRoute,
    private dataUtilService: DataUtilService
  ) { }

  ngOnInit() {
    this.limpar();

    this.carregarPerfil.carregar(this.activatedRoute.snapshot.data.perfilAcesso, this.perfilAcesso);

    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;

    this.dataSource.filterPredicate = (data: any, filter) => {
      const dataStr = data.aluno.pessoaFisica.nome +
                      data.aluno.matriculaAluno +
                      data.dataFrequencia +
                      data.justificativa +
                      data.frequencia;
      return dataStr.toUpperCase().indexOf(filter.toUpperCase()) !== -1;
    };

    this.unidadeService.getAllByInstituicaoDaUnidadeLogada().subscribe((unidades: Unidade[]) => {
      this.unidades = unidades;
    });
  }

  applyFilter(filterValue: string) {
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  limpar() {
    this.filtroBusca = new FiltroBusca();
    this.mostrarTabela = false;
    this.msg = null;
    this.dataSource.data = [];
    this.listaFrequenciaAlunoUnidade = [];
    this.frequenciaAlunoUnidade = new FrequenciaAlunoUnidade();
  }

  editar(frequenciaAluno: FrequenciaAlunoUnidade) {
    frequenciaAluno.desabilitado = !frequenciaAluno.desabilitado;
  }

  atualizar() {

    const registrosParaAtualizar = this.listaFrequenciaAlunoUnidade.filter(frequencia => frequencia.presenca || frequencia.ausencia);

    this.frequenciaAlunoService.alterarAllPorUnidade(registrosParaAtualizar, this.filtroBusca.unidade.idUnidade, this.filtroBusca.dataReferencia)
    .subscribe(() => {
      this.toastService.showSucesso('Frequência de alunos atualizada com sucesso');
      this.consultar();
    });
  }

  gerarListaFrequencia() {
    if (this.filtroBusca.dataReferencia === undefined) {
      this.toastService.showAlerta('Informe a data de frequência.');
      return;
    }

    this.frequenciaAlunoService.getListaFrequenciaAlunosUnidade(
      this.filtroBusca.unidade.idUnidade, this.filtroBusca.dataReferencia)
    .subscribe((frequenciasAlunoUnidade: FrequenciaAlunoUnidade[]) => {
        this.listaFrequenciaAlunoUnidade = frequenciasAlunoUnidade ? frequenciasAlunoUnidade : [];
        this.dataSource.data = this.listaFrequenciaAlunoUnidade;
        this.mostrarTabela = true;

        this.listaFrequenciaAlunoUnidade.forEach(frequenciaAlunoUnidade => {
          frequenciaAlunoUnidade.ausencia = !frequenciaAlunoUnidade.presenca && !!frequenciaAlunoUnidade.id;
          frequenciaAlunoUnidade.desabilitado = !!frequenciaAlunoUnidade.id;
        }); 
    });
  }

  consultar() {

    if (this.filtroBusca.dataReferencia === undefined) {
      this.toastService.showAlerta('Informe a data de frequência.');
      return;
    }

    this.frequenciaAlunoService.getListaFrequenciaAlunosUnidade(this.filtroBusca.unidade.idUnidade, 
      this.filtroBusca.dataReferencia).subscribe((frequenciasAlunoUnidade: FrequenciaAlunoUnidade[]) => {
        this.listaFrequenciaAlunoUnidade = frequenciasAlunoUnidade ? frequenciasAlunoUnidade : [];
        this.dataSource.data = this.listaFrequenciaAlunoUnidade;
        this.mostrarBotaoGerarListaFrequencia = true;
        this.mostrarTabela = false;
        if (this.listaFrequenciaAlunoUnidade.length > 0) {
          this.mostrarTabela = true;
        }

        this.listaFrequenciaAlunoUnidade.forEach(frequenciaAlunoUnidade => {
          frequenciaAlunoUnidade.ausencia = !frequenciaAlunoUnidade.presenca && !!frequenciaAlunoUnidade.id;
          frequenciaAlunoUnidade.desabilitado = !!frequenciaAlunoUnidade.id;
        });       
    });

  }

  isFiltroPreenchido() {
    return this.filtroBusca.dataReferencia && this.filtroBusca.unidade.idUnidade;
  }

  onMascaraDataInput(event) {
    return this.dataUtilService.onMascaraDataInput(event);
  }
  
  onPresencaChange(element: FrequenciaAlunoUnidade): void {
    if (element.presenca) {
      element.ausencia = false;
    }
  }

  onAusenciaChange(element: FrequenciaAlunoUnidade): void {
    if (element.ausencia) {
      element.presenca = false;
    }
  }

}

